module.exports = __webpack_public_path__ + "static/img/15.329aae0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/15.png
// module id = qu/p
// module chunks = 0